import React from 'react'
import HeaderWithoutAuthorization from 'components/blocks/Header/HeaderWithoutAuthorization'
import AffiliationVerificationForm from './AffiliationVerificationForm'
const VerificationNewUserData = () => {
  return (
    <div>
        <HeaderWithoutAuthorization  />
        <div className="container">
            <AffiliationVerificationForm />

        </div>
    </div>
  )
}

export default VerificationNewUserData